export default {
  main: '#000000',
  secondary: '#EBC15B',
  contrastingColor: '#ffffff',
  priceColor: '#000000',
  entryBackground: '#000000',
  menuBackgroundColor: '#ffffff',
  menuTextColor: '#ffffff',
};
